import { gql } from "graphql-request";

export const CREATE_USER = gql`
  mutation CreateUser($userData: CreateUserInput!) {
    createUser(userData: $userData) {
      data
    }
  }
`;
export const EDIT_USER = gql`
  mutation UpdateUserById($userId: String!, $userData: UpdateUserInput!) {
    updateUserById(userId: $userId, userData: $userData) {
      data
    }
  }
`;
export const DELETE_USER = gql`
  mutation DeleteUserById($userId: String!) {
    deleteUserById(userId: $userId) {
      data
    }
  }
`;

export const GET_ALL_TD_CLIENTS = gql`
  query GetAllTdClients(
    $pageNo: Int
    $pageSize: Int
    $searchKeyword: String
    $startDate: String
    $endDate: String
    $isRestricted: Boolean
    $role: String
  ) {
    getAllTdClients(
      pageNo: $pageNo
      pageSize: $pageSize
      searchKeyword: $searchKeyword
      startDate: $startDate
      endDate: $endDate
      isRestricted: $isRestricted
      role: $role
    ) {
      data {
        accessLevel
        createdAt
        firstName
        isRestricted
        lastName
        email
        _id
        allowedPages
      }
      meta {
        countDocs
      }
    }
  }
`;

export const UPDATE_USER_STATUS = gql`
  mutation UpdateUserBlockStatus($email: String, $isRestricted: Boolean) {
    updateUserBlockStatus(email: $email, isRestricted: $isRestricted) {
      data
      meta {
        countDocs
        pageNo
        pageSize
      }
    }
  }
`;
